import type { BlogCard } from './types';

export function getBlogImplementedPath(blog: Pick<BlogCard, 'slug'>): string {
  const basePath = '/blogs';

  return blog.slug ? `${basePath}/${blog.slug}` : basePath;
}
